module.exports = __webpack_public_path__ + "img/astro4.97af858a.jpg";